import { render, staticRenderFns } from "./shebeipeizhi.vue?vue&type=template&id=fcd7cb8c&scoped=true&"
import script from "./shebeipeizhi.vue?vue&type=script&lang=js&"
export * from "./shebeipeizhi.vue?vue&type=script&lang=js&"
import style0 from "./shebeipeizhi.vue?vue&type=style&index=0&id=fcd7cb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd7cb8c",
  null
  
)

export default component.exports